import { auth0ApiClient } from './auth0ApiClient'

export enum CuratedFeedTopic {
  LEADERSHIP_MANAGEMENT = 'Leadership & Management',
  CAREER_GROWTH_COACHING = 'Career Growth & Coaching',
  MENTORSHIP_SPECIFIC = 'Mentorship-specific',
  INDUSTRY_TECH_NEWS = 'Industry/Tech News'
}

export interface CuratedSourceHealth {
  lastPolledAt: string | null
  lastSuccessAt: string | null
  consecutiveFailures: number
  lastError: string | null
}

export interface CuratedSource {
  id: string
  name: string
  feedUrl: string
  topic: CuratedFeedTopic
  enabled: boolean
  health: CuratedSourceHealth
  createdAt: string
  updatedAt: string
}

export interface CreateCuratedSourceInput {
  name: string
  feedUrl: string
  topic: CuratedFeedTopic
}

export interface UpdateCuratedSourceInput {
  name?: string
  topic?: CuratedFeedTopic
}

interface CuratedSourceListEnvelope {
  success: boolean
  data: CuratedSource[]
}

class CuratedSourceService {
  private readonly baseUrl = '/feed/curated/admin/sources'

  async listSources(): Promise<CuratedSource[]> {
    const envelope = await auth0ApiClient.getEnvelope<CuratedSourceListEnvelope>(this.baseUrl)
    return envelope.data
  }

  async createSource(input: CreateCuratedSourceInput): Promise<CuratedSource> {
    return auth0ApiClient.post(this.baseUrl, input)
  }

  async updateSource(id: string, input: UpdateCuratedSourceInput): Promise<CuratedSource> {
    return auth0ApiClient.put(`${this.baseUrl}/${id}`, input)
  }

  async setEnabled(id: string, enabled: boolean): Promise<CuratedSource> {
    return auth0ApiClient.patch(`${this.baseUrl}/${id}/enabled`, { enabled })
  }

  async deleteSource(id: string): Promise<void> {
    await auth0ApiClient.delete(`${this.baseUrl}/${id}`)
  }
}

export const curatedSourceService = new CuratedSourceService()
